import { useCallback } from "react";

/** Principal-type toggles: PG vs Attorney vs manual scaffolding. */
export function useBondPrincipalPrincipalTypeHandlers({
  cfg,
  keys,
  data,
  updateData,
  updateGuardianAt,
}) {
  const handleProfessionalGuardianChange = useCallback(
    (index, value, guardianRow, guardians) => {
      if (cfg.kind === "guardianship") {
        const updatedGuardians = [...guardians];
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          is_professional_guardian: value,
          showFullForm: value === "Yes" ? guardianRow.showFullForm : false,
          professional_guardian: null,
          is_new_pg: false,
          attorney: null,
          pg_gia_on_file: false,
          pg_loa_on_file: false,
          attorney_gia_on_file: false,
          is_esignatures_principal: "No",
          credit_report_principal: "",
        };
        updateData({ ...data, guardians: updatedGuardians });
        return;
      }

      if (cfg.clearFieldsOnPgNo) {
        const updatedGuardians = [...guardians];
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          is_professional_guardian: value,
          professional_guardian: null,
          showFullForm: value === "Yes" ? guardianRow.showFullForm : false,
          is_new_pg: false,
          is_attorney: "No",
          attorney: null,
        };
        if (value === "No") {
          [
            keys.name,
            keys.address,
            keys.city,
            keys.state,
            keys.zip,
            keys.occupation,
            keys.relationship,
            keys.citizenship,
            keys.country,
            keys.ssn,
          ].forEach((field) => {
            delete updatedGuardians[index][field];
          });
        }
        updateData({ ...data, guardians: updatedGuardians });
        return;
      }

      const patch = {
        is_professional_guardian: value,
        showFullForm: value === "Yes" ? guardianRow.showFullForm : false,
        professional_guardian: null,
        is_new_pg: false,
      };
      if (cfg.pgChangeClearsAttorney) {
        patch.attorney = null;
      }
      updateGuardianAt(index, patch, guardians);
    },
    [cfg, data, keys, updateData, updateGuardianAt]
  );

  const handleAttorneyChange = useCallback(
    (index, value, guardians) => {
      if (cfg.clearFieldsOnAttorneyNo) {
        const updatedGuardians = [...guardians];
        updatedGuardians[index] = {
          ...updatedGuardians[index],
          is_attorney: value,
          is_professional_guardian: "No",
          professional_guardian: null,
          attorney: null,
          showAttorneyForm: false,
          is_attorney_home: "No",
        };
        if (cfg.pgFetchIncludesGiaLoa) {
          updatedGuardians[index].attorney_gia_on_file = false;
          updatedGuardians[index].pg_gia_on_file = false;
          updatedGuardians[index].pg_loa_on_file = false;
          updatedGuardians[index].is_esignatures_principal = "No";
          updatedGuardians[index].credit_report_principal = "";
        }
        if (value === "No") {
          const fieldsToRemove = cfg.pgFetchIncludesGiaLoa
            ? [
                keys.name,
                keys.address,
                keys.city,
                keys.state,
                keys.zip,
                keys.occupation,
                keys.relationship,
                keys.citizenship,
                "country",
                keys.ssn,
                "is_attorney_home",
              ]
            : [
                keys.name,
                keys.address,
                keys.city,
                keys.state,
                keys.zip,
                keys.occupation,
                keys.relationship,
                keys.citizenship,
                keys.country,
                keys.ssn,
                "is_attorney_home",
              ];
          fieldsToRemove.forEach((field) => {
            delete updatedGuardians[index][field];
          });
        }
        updateData({ ...data, guardians: updatedGuardians });
        return;
      }

      updateGuardianAt(
        index,
        {
          is_attorney: value,
          attorney: null,
          showAttorneyForm: false,
        },
        guardians
      );
    },
    [cfg, data, keys, updateData, updateGuardianAt]
  );

  return { handleProfessionalGuardianChange, handleAttorneyChange };
}
